import api from "../../services/api";
import {
  CLEAR_USER_STATE,
  IS_EMAIL_AVAILABLE_FAILURE,
  IS_EMAIL_AVAILABLE_REQUEST,
  IS_EMAIL_AVAILABLE_SUCCESS,
  IS_USERNAME_AVAILABLE_FAILURE,
  IS_USERNAME_AVAILABLE_REQUEST,
  IS_USERNAME_AVAILABLE_SUCCESS,
  UPDATE_USER_BASIC_PROFILE_FAILURE,
  UPDATE_USER_BASIC_PROFILE_REQUEST,
  UPDATE_USER_BASIC_PROFILE_SUCCESS,
} from "./ActionType";

const isUsernameAvailableRequest = () => {
  return {
    type: IS_USERNAME_AVAILABLE_REQUEST,
  };
};

const isUsernameAvailableSuccess = (isAvailable) => {
  return {
    type: IS_USERNAME_AVAILABLE_SUCCESS,
    payload: isAvailable,
  };
};

const isUsernameAvailableFailure = (error) => {
  return {
    type: IS_USERNAME_AVAILABLE_FAILURE,
    payload: error,
  };
};

export const isUsernameAvailable = (username) => async (dispatch) => {
  dispatch(isUsernameAvailableRequest());
  try {
    const response = await api.get(
      `/auth/public/check-username?username=${username}`
    );

    dispatch(isUsernameAvailableSuccess(response.data));
  } catch (error) {
    dispatch(isUsernameAvailableFailure(error.response.data));
  }
};

const isEmailAvailableRequest = () => {
  return {
    type: IS_EMAIL_AVAILABLE_REQUEST,
  };
};

const isEmailAvailableSuccess = (isAvailable) => {
  return {
    type: IS_EMAIL_AVAILABLE_SUCCESS,
    payload: isAvailable,
  };
};

const isEmailAvailableFailure = (error) => {
  return {
    type: IS_EMAIL_AVAILABLE_FAILURE,
    payload: error,
  };
};

export const isEmailAvailable = (email) => async (dispatch) => {
  dispatch(isEmailAvailableRequest());
  try {
    const response = await api.get(`/auth/public/check-email?email=${email}`);

    dispatch(isEmailAvailableSuccess(response.data));
  } catch (error) {
    dispatch(isEmailAvailableFailure(error.response.data));
  }
};

const updateUserBasicProfileRequest = () => {
  return {
    type: UPDATE_USER_BASIC_PROFILE_REQUEST,
  };
};

const updateUserBasicProfileSuccess = (data) => {
  return {
    type: UPDATE_USER_BASIC_PROFILE_SUCCESS,
    payload: data,
  };
};

const updateUserBasicProfileFailure = (error) => {
  return {
    type: UPDATE_USER_BASIC_PROFILE_FAILURE,
    payload: error,
  };
};

export const updateUserBasicProfile = (userData) => async (dispatch) => {
  dispatch(updateUserBasicProfileRequest());
  try {
    const response = await api.put("/users/basic-profile", userData);
    dispatch(updateUserBasicProfileSuccess(response.data));
  } catch (error) {
    dispatch(updateUserBasicProfileFailure(error.response.data));
  }
};

export const clearUserState = () => {
  return {
    type: CLEAR_USER_STATE,
  };
};
